/** Inputs to the selection-summary visibility decision. */
export type PivotSummaryVisibility = { isDragging: boolean; inView: boolean; wasVisible: boolean }

/** Resolves the selection-summary overlay visibility — while the pointer drives the selection the last settled state holds, since re-evaluating per scroll pixel would toggle it mid-drag; otherwise the settled in-view check rules. */
export const resolvePivotSummaryVisible = ({ isDragging, inView, wasVisible }: PivotSummaryVisibility): boolean =>
  isDragging ? wasVisible : inView
